// One DrChrono account serves every environment, so the host is a constant and
// the variable exists only to point a build elsewhere. `??`, not `||`: setting
// it to an empty value is how you turn the links off.
const DEFAULT_CHART_BASE_URL = 'https://cbilitsisdc.drchrono.com';
const CHART_BASE_URL = process.env.VUE_APP_DRCHRONO_CHART_BASE_URL ?? DEFAULT_CHART_BASE_URL;

/**
 * Deep link into the DrChrono web UI, which lives on the practice's own
 * subdomain. Null when the row carries no chart or the host was blanked, so
 * callers render it unlinked rather than sending staff to a 404.
 */
export function chartUrl(externalId: number | string | null | undefined): string | null {
  const id = Number(externalId);
  const base = CHART_BASE_URL.replace(/\/+$/, '');

  if (!base || !Number.isInteger(id) || id <= 0) {
    return null;
  }

  return `${base}/chart/${id}/summary`;
}
